export default () => {
  return {
    editorCopyBlocksLoading: true
  };
};
